<template>
  <!-- Wyświetla zdjęcie pojazdu. Kliknięcie pozwala przełączać zdjęcia (jeśli dostępne) -->
  <img
    :src="srcImage"
    :class="[
      'img-fluid',
      'fitted-image',
      { 'fitted-image--list': source === 'vehicle-list' },
      { 'fitted-image--placeholder': isPlaceholder && source === 'vehicle-list' }
    ]"
    @click="switchImage"
    @error="handleImageError"
  />
</template>

<script>
import moment from 'moment'
import noImage from '@/assets/no_image.png'

export default {
  props: {
    vehicle: {required: true},                // Obiekt pojazdu
    imageService: {required: true},           // Serwis do pobierania zdjęć
    imageNumber: {required: false},           // Numer zdjęcia (opcjonalnie)
    noSwitch: {required: false},              // Czy można przełączać zdjęcia
    setImageWithNumber: {required: false},    // Zewnętrzne wymuszenie numeru zdjęcia
    source: {
      type: String,
      default: 'unknown'
    }
  },
  components: {},
  data() {
    return {
      srcImage: noImage,       // Źródło aktualnego zdjęcia (base64/url lub fallback)
      moment: moment,          // Biblioteka do dat
      imageNumberUsed: '',     // Numer aktualnie wyświetlanego zdjęcia
      imageSwitchPossible: false,  // Czy możliwa jest zmiana zdjęcia kliknięciem
      isPlaceholder: true,
    }
  },
  name: "VehicleImage", 
  created() {
    // Ustalenie, które zdjęcie pokazać na starcie (domyślnie pierwsze, jeśli są jakieś)
    this.imageNumberUsed = this.imageNumber ? this.imageNumber : (this.vehicle.images && this.vehicle.images.length > 0 ? 1 : 0);
    // Pobranie zdjęcia na start
    this.getImage(this.vehicle, this.getImageType(), this.vehicle.location.id, this.getCreatedAt(this.vehicle));
    // Ustalenie, czy można przełączać zdjęcia
    if (this.noSwitch) {
      this.imageSwitchPossible = false;
    } else {
      this.imageSwitchPossible = this.noSwitch;
    }
    // Obserwator na zewnętrzną zmianę numeru zdjęcia (props)
    this.$watch(
        () => this.setImageWithNumber,
        (newVal) => {
          // Jeśli nowy numer jest dostępny w liście zdjęć, ustaw i pobierz to zdjęcie
          if (this.vehicle.images.length >= newVal) {
            this.imageNumberUsed = newVal;
            this.getImage(this.vehicle, newVal, this.vehicle.location.id, this.getCreatedAt(this.vehicle));
            // Wywołaj callback do rodzica
            this.wasSet(newVal);
          }
        },
        {immediate: true}
    )
  },
  methods: {
    // Informuje rodzica, że ustawiono nowe zdjęcie
    wasSet(newVal){
      this.$emit("wasSet", newVal);
    },
    // Zwraca typ zdjęcia na podstawie numeru
    getImageType() {
      if (this.imageNumberUsed !== 0 && this.vehicle.images.length >= this.imageNumberUsed) {
        return this.vehicle.images[this.imageNumberUsed - 1].type;
      }
      return 0;
    },
    handleImageError() {
      this.srcImage = noImage;
      this.isPlaceholder = true;
    },
    // Kliknięcie przełącza na kolejne zdjęcie (jeśli jest ich więcej niż jedno)
    switchImage() {
      if (!this.imageSwitchPossible) {
        let totalNumber = this.vehicle.images && this.vehicle.images.length > 0 ? this.vehicle.images.length : 0;
        if (totalNumber === this.imageNumberUsed) {
          this.imageNumberUsed = 1;
        } else {
          this.imageNumberUsed = this.imageNumberUsed + 1;
        }
        this.getImage(this.vehicle, this.getImageType(), this.vehicle.location.id, this.getCreatedAt(this.vehicle));
      }
    },
    // Pobiera zdjęcie pojazdu (z serwisu lub z listy, jeśli jest już załadowane)
    async getImage(vehicle, typeId, location, createdAt) {
      if (typeId && typeId !== 0) {
        try {
          let fetched

          if (this.source === 'vehicle-list' && typeId === 1) {
            fetched = await this.imageService.getImageWithScale(vehicle.id, typeId, location)
          } else {
            fetched = await this.imageService.getImage(vehicle.id, typeId, location, createdAt)
          }

          const data = await this.blobToBase64(fetched)
          this.srcImage = data
          this.isPlaceholder = false
        } catch (error) {
          console.error(error)
          this.srcImage = noImage
          this.isPlaceholder = true
        }
      } else {
        this.srcImage = noImage
        this.isPlaceholder = true
      }

      return undefined
    },
    // Zamienia blob (np. z fetch) na base64 dla <img src="">
    blobToBase64(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise(resolve => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },

    // Zwraca datę utworzenia rekordu pojazdu w formacie ISO (potrzebne do pobierania zdjęcia)
    getCreatedAt(vehicle) {
      return this.moment(vehicle.createdAt).toISOString(false);
    }
  }
}
</script>

<style scoped>
/* .fitted-image--list {
  width: 70% !important;
  max-width: 70% !important;
  height: auto !important;
  max-height: none !important;
  object-fit: contain;
  margin: auto;
  display: block;
} */
.fitted-image {
  display: block;
}

.fitted-image--list {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: cover;
  margin: 0;
}

.fitted-image--placeholder {
  object-fit: contain !important;
  width: 85% !important;
  height: 85% !important;
  max-width: 85% !important;
  max-height: 85% !important;
  margin: auto;
}
</style>
